import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { NewsletterSignup } from "./NewsletterSignup";

const Brand = () => (
  <div className="mb-4">
    <span className="inline-flex bg-white rounded-md px-4 py-2.5 items-center shadow-md shadow-black/30">
      <img src="/globus-lockup.png" alt="Globus Financial Services" className="h-10 w-auto object-contain" />
    </span>
  </div>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-slate3/60">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-14 pb-4 border-b border-white/10">
      <div className="grid md:grid-cols-2 gap-6 items-center pb-10">
        <div>
          <p className="overline-label mb-2">Weekly newsletter</p>
          <p className="font-serif text-xl sm:text-2xl">The week's RBI &amp; lending moves, every Monday.</p>
        </div>
        <NewsletterSignup testId="footer-newsletter" />
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-3 gap-10">
      <div>
        <Brand />
        <p className="font-serif italic text-gold mb-3">Connecting Capital. Creating Growth.</p>
        <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
          Independent debt advisory for corporates and individuals. We negotiate with lenders so you don't have to.
        </p>
      </div>
      <div>
        <p className="text-xs tracking-[0.25em] uppercase text-muted-foreground mb-5">Navigate</p>
        <nav className="flex flex-col gap-3 text-sm text-[#A0AAB2]">
          <a data-testid="footer-services" href="#services" className="hover:text-gold transition-colors">Services</a>
          <a data-testid="footer-calculators" href="#calculators" className="hover:text-gold transition-colors">Calculators</a>
          <Link data-testid="footer-invoice-discounting" to="/invoice-discounting" className="hover:text-gold transition-colors">Invoice Discounting</Link>
          <Link data-testid="footer-partners" to="/partners" className="hover:text-gold transition-colors">Partner with us</Link>
          <Link data-testid="footer-team" to="/team" className="hover:text-gold transition-colors">Our Team</Link>
          <Link data-testid="footer-insights" to="/insights" className="hover:text-gold transition-colors">Insights</Link>
          <Link data-testid="footer-track" to="/track" className="hover:text-gold transition-colors">Track Application</Link>
          <a data-testid="footer-enquire" href="#enquire" className="hover:text-gold transition-colors">Enquire</a>
        </nav>
      </div>
      <div>
        <p className="text-xs tracking-[0.25em] uppercase text-muted-foreground mb-5">Contact</p>
        <div className="text-sm text-[#A0AAB2] space-y-3">
          <p className="flex items-center gap-2">
            <Phone size={14} className="text-gold" /> +91 87965 12777
            <a
              data-testid="footer-whatsapp"
              href="https://wa.me/918796512777"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chat on WhatsApp"
              className="text-[#25D366] hover:scale-110 transition-transform"
            >
              <WhatsAppIcon size={18} />
            </a>
          </p>
          <p>info@globusfinancialservices-in.com</p>
          <p>HC-3, 3rd Floor, Durga Apartment<br />761 Shalimar Garden Ext-1, Sahibabad<br />Ghaziabad, Uttar Pradesh-201005</p>
          <p className="text-xs text-muted-foreground">GSTIN: 09AEFPK4400F1ZW</p>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-muted-foreground">
        <p>© {new Date().getFullYear()} Globus Financial Services. All rights reserved.</p>
        <nav className="flex gap-5">
          <Link data-testid="footer-privacy-link" to="/privacy-policy" className="hover:text-gold transition-colors">Privacy Policy</Link>
          <Link data-testid="footer-disclaimer-link" to="/disclaimer" className="hover:text-gold transition-colors">Disclaimer & Terms</Link>
        </nav>
        <p>Loans are subject to lender approval and applicable regulations.</p>
      </div>
    </div>
  </footer>
);
